import React, { Component, ComponentType } from 'react';

export interface IWithErrorHandler {
  error: string;
  onError: (error: any) => void;
  onErrorClose: () => void;
}

interface IState {
  errorState: string;
}

const withErrorHandler = (ChildComponent: ComponentType<IWithErrorHandler>) => {
  class WithErrorHandler extends Component<IWithErrorHandler, IState> {
    state: IState = {
      errorState: '',
    };

    handleError = (error: any) => {
      const errorState = error.message ? error.message : error;
      this.setState({ errorState });
    };

    resetError = () => {
      this.setState({ errorState: null });
    };

    render() {
      const { ...props } = this.props;
      const { errorState } = this.state;

      return (
        <ChildComponent
          onError={this.handleError}
          onErrorClose={this.resetError}
          error={errorState}
          {...props}
        />
      );
    }
  }

  return WithErrorHandler;
};

export { withErrorHandler };
